(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canilume-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cl-product__gallery').forEach(function (gallery) {
    var mainImage = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.cl-product__form').forEach(function (form) {
    if (form.dataset.canilumeOfferReady === 'true') return;
    form.dataset.canilumeOfferReady = 'true';

    var offerInputs = form.querySelectorAll('[data-offer]');
    var primaryVariant = form.querySelector('[data-primary-variant]');
    var secondaryVariant = form.querySelector('[data-secondary-variant]');
    var secondaryColor = form.querySelector('[data-secondary-color]');
    var primaryLabel = form.querySelector('[data-primary-color-label]');
    var quantity = form.querySelector('[data-offer-quantity]');
    var submitLabel = form.querySelector('[data-submit-label]');
    var submitButton = form.querySelector('button[type="submit"]');
    var duoNote = form.querySelector('[data-duo-note]');
    var errorMessage = form.querySelector('[data-form-error]');
    var discountCodeInput = form.querySelector('[data-duo-discount-code]');
    var cartRootInput = form.querySelector('[data-cart-root]');

    function selectedOffer() {
      return form.querySelector('[data-offer]:checked');
    }

    function updateOffer() {
      var offer = selectedOffer();
      var isDuo = offer && offer.dataset.offer === 'duo';
      if (secondaryColor) secondaryColor.hidden = !isDuo;
      if (duoNote) duoNote.hidden = !isDuo;
      if (quantity) quantity.value = isDuo ? '2' : '1';
      if (primaryLabel) primaryLabel.textContent = isDuo ? 'Coloris de la première brosse' : 'Choisissez votre coloris';
      if (submitLabel) {
        var selectedOption = primaryVariant.options[primaryVariant.selectedIndex];
        var singlePrice = selectedOption ? selectedOption.dataset.price : '';
        submitLabel.textContent = isDuo ? 'Ajouter le Duo · 59,90 €' : 'Ajouter au panier · ' + singlePrice;
      }
    }

    offerInputs.forEach(function (input) {
      input.addEventListener('change', updateOffer);
    });
    primaryVariant.addEventListener('change', updateOffer);
    var requestedOffer = new URLSearchParams(window.location.search).get('offre');
    if (requestedOffer === 'duo') {
      var duoOffer = form.querySelector('[data-offer="duo"]');
      if (duoOffer) duoOffer.checked = true;
    }
    updateOffer();

    form.addEventListener('submit', async function (event) {
      var offer = selectedOffer();
      if (!offer || offer.dataset.offer !== 'duo') return;

      event.preventDefault();
      if (errorMessage) errorMessage.hidden = true;
      submitButton.disabled = true;

      var root = cartRootInput && cartRootInput.value ? cartRootInput.value : '/';
      if (!root.endsWith('/')) root += '/';
      var discountCode = discountCodeInput ? discountCodeInput.value.trim() : '';
      var primaryId = Number(primaryVariant.value);
      var secondaryId = secondaryVariant ? Number(secondaryVariant.value) : primaryId;
      var items = [];

      if (primaryId === secondaryId) {
        items.push({ id: primaryId, quantity: 2, properties: { _Offre: 'Duo Compagnons' } });
      } else {
        items.push({ id: primaryId, quantity: 1, properties: { _Offre: 'Duo Compagnons' } });
        items.push({ id: secondaryId, quantity: 1, properties: { _Offre: 'Duo Compagnons' } });
      }

      try {
        var addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addResponse.ok) throw new Error('cart_add_failed');

        var discountResponse = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: discountCode })
        });
        if (!discountResponse.ok) throw new Error('discount_apply_failed');

        window.location.assign(root + 'cart');
      } catch (error) {
        if (errorMessage) errorMessage.hidden = false;
        submitButton.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
